import {inlineError} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

/**
 * @class
 * @implements UseCase
 */
class ResetUnseenSavedSearchMatchesByIdUseCase extends UseCase {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Object} deps.config
   * @param {Function} deps.repository
   * @param {Function} deps.getCurrentUserService

   */
  constructor({config, repository, getCurrentUserService}) {
    super()

    this._config = config
    this._repository = repository
    this._getCurrentUserService = getCurrentUserService
  }

  /**
   * @return {Promise<Number>} number of unread messages
   */
  @inlineError
  async execute({alertId}) {
    const userEntity = await this._getCurrentUserService.execute()
    const userId = userEntity.getId()

    return this._repository.resetUnseenSavedSearchMatchesById({
      userId,
      alertId
    })
  }
}

export default ResetUnseenSavedSearchMatchesByIdUseCase
